import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import Avatar from './Avatar';
import { startCase } from 'lodash';
import { ConversationType, utils } from 'kb-shared';

const { nameToInitials } = utils;

interface Props {
  conversation: ConversationType;
  active: boolean;
  onClick: (arg0: number) => void;
  idx: number;
}

const ConversationPreview = ({ conversation, active, onClick, idx }: Props) => {
  const {
    id,
    assignedToUserName,
    assignedToUserPhotoUrl,
    category,
    subject,
    preview,
    unreadCount,
    lastMessageTimestamp
  } = conversation;
  const timeStamp = moment(lastMessageTimestamp).fromNow();
  const teamName = `${startCase(category)} Team`;
  const displayName = assignedToUserName || teamName;

  return (
    <Conversation key={id} active={active} onClick={() => onClick(idx)}>
      <AvatarWrapper>
        <Avatar src={assignedToUserPhotoUrl} initials={nameToInitials(displayName)} />
        {unreadCount > 0 && <UnreadBubble>{unreadCount}</UnreadBubble>}
      </AvatarWrapper>
      <ConversationInfo>
        <MessageHeader>
          <Username>{displayName}</Username> <span>{timeStamp}</span>
        </MessageHeader>
        <Subject unread={unreadCount > 0}>{subject}</Subject>
        <Preview>{preview}</Preview>
      </ConversationInfo>
    </Conversation>
  );
};

export default ConversationPreview;

interface ActiveProps {
  readonly active: boolean;
}
const Conversation = styled.li<ActiveProps>`
  background-color: ${({ active, theme }) =>
    active ? theme.colors.beige : theme.colors.beigeLight};
  padding: 15px;
  display: grid;

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    grid-template-columns: 12% auto;
    grid-column-gap: 1em;
    padding: 10px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    padding: 10px;
  }
  cursor: pointer;
`;

const MessageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.nightLight};
`;
interface UnreadProps {
  readonly unread: boolean;
}
const Subject = styled.div<UnreadProps>`
  font-weight: ${({ unread }) => (unread ? 'bold' : 'initial')};
  text-overflow: ellipsis;
  overflow: hidden;
`;

const Preview = styled.p`
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: smaller;
`;

const ConversationInfo = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    margin-left: 15px;
  }
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Username = styled.span`
  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    display: none;
  }
`;

const AvatarWrapper = styled.div`
  position: relative;
  width: fit-content;
`;

const UnreadBubble = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: ${({ theme }) => theme.colors.KBYellow};
  border-radius: 50%;
  padding: 7px;
  line-height: 5px;
  font-size: small;
`;
